"use client"

import { RefreshCw } from "lucide-react"
import { cn } from "@/lib/utils"

interface LiveIndicatorProps {
  active: boolean
  pollMs: number
  className?: string
}

/**
 * Small pill rendered top-right of LiveDataTable. Shows refresh state
 * + cadence so users know the table is live without needing to F5.
 */
export function LiveIndicator({ active, pollMs, className }: LiveIndicatorProps) {
  const seconds = Math.round(pollMs / 1000)
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium",
        active
          ? "border-blue-500/30 bg-blue-500/10 text-blue-700 dark:text-blue-300"
          : "border-muted bg-muted text-muted-foreground",
        className,
      )}
      aria-live="polite"
    >
      <RefreshCw
        className={cn("h-3 w-3", active && "animate-spin [animation-duration:2s]")}
        aria-hidden
      />
      {active ? `Auto-refresh ${seconds}s` : "Live updates off"}
    </div>
  )
}
